import React from 'react';
import PropTypes from 'prop-types';
import setAuthCredentials from '../../setAuthCredentials';
import AuthLoginByTokenComponent from './AuthLoginByTokenComponent';
import UserDataOnDemand from '../../../ApolloConnectors/UserData/UserDataConnectorApollo';

class AuthLoginByTokenContainer extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  getStateFromLocalStorage = () => {
    if (!window.localStorage) {
      return null;
    }

    const token = window.localStorage.getItem('token');
    if (!token) {
      return null;
    }

    window.localStorage.setItem('authenticatedByQueryString', false);

    return token;
  };

  getStateFromCookies = () => {
    const token = document.cookie.match('(^|;) ?Authentication=([^;]*)(;|$)');

    if (token) {
      setAuthCredentials(token[2]);
      return token[2];
    }

    return null;
  };

  getInitialToken = () => {
    let token = this.getStateFromLocalStorage();

    if (this.getStateFromCookies()) {
      token = this.getStateFromCookies();
    }

    return token;
  };

  render() {
    return (
      <UserDataOnDemand>
        {({ ...userDataOnDemand }) => (
          <AuthLoginByTokenComponent token={this.getInitialToken()} {...userDataOnDemand}>
            {this.props.children}
          </AuthLoginByTokenComponent>
        )}
      </UserDataOnDemand>
    );
  }
}

export default AuthLoginByTokenContainer;
